var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home_page_wrap" },
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { staticClass: "home_page_main" }, [
        _c("div", { staticClass: "home_page_menu" }, [
          _vm.isOpen
            ? _c("div", { staticClass: "home_page_menu_box" }, [
                _c(
                  "ul",
                  [
                    _vm._l(_vm.menuList, function(item, index) {
                      return _c(
                        "li",
                        {
                          key: index,
                          class: { active: index === _vm.curId },
                          on: {
                            click: function($event) {
                              return _vm.tabSwitch(item, index)
                            }
                          }
                        },
                        [
                          _vm.iconToo[item.name]
                            ? _c("span", {
                                staticClass: "icon",
                                style: {
                                  backgroundImage:
                                    "url(" +
                                    (index === _vm.curId
                                      ? _vm.iconToo[item.name].ActiveSrc
                                      : _vm.iconToo[item.name].src) +
                                    ")"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(item.name))])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.professional == 2
                      ? _c(
                          "li",
                          {
                            on: {
                              click: function($event) {
                                return _vm.openUrl("税收政策库")
                              }
                            }
                          },
                          [
                            _c("span", {
                              staticClass: "icon",
                              style: {
                                backgroundImage:
                                  "url(" + _vm.iconToo["税收政策库"].src + ")"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("税收政策库")])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.professional === "1" && _vm.productFlag === "3"
                      ? _c(
                          "li",
                          {
                            on: {
                              click: function($event) {
                                return _vm.openUrl("审计准则")
                              }
                            }
                          },
                          [
                            _c("span", {
                              staticClass: "icon",
                              style: {
                                backgroundImage:
                                  "url(" + _vm.iconToo["审计准则"].src + ")"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("审计准则")])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.professional === "1" && _vm.productFlag === "3"
                      ? _c(
                          "li",
                          {
                            on: {
                              click: function($event) {
                                return _vm.openUrl("会计准则")
                              }
                            }
                          },
                          [
                            _c("span", {
                              staticClass: "icon",
                              style: {
                                backgroundImage:
                                  "url(" + _vm.iconToo["会计准则"].src + ")"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("会计准则")])
                          ]
                        )
                      : _vm._e()
                  ],
                  2
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isOpen
            ? _c("img", {
                staticClass: "switchImg close",
                attrs: {
                  src: require("../../../static/images/course/close.png"),
                  alt: ""
                },
                on: {
                  click: function($event) {
                    _vm.isOpen = false
                  }
                }
              })
            : _c("img", {
                staticClass: "switchImg open",
                attrs: {
                  src: require("../../../static/images/course/open.png"),
                  alt: ""
                },
                on: {
                  click: function($event) {
                    _vm.isOpen = true
                  }
                }
              })
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "home_page_content",
            style: _vm.isOpen ? "width: calc(100% - 120px)" : "width: 100%"
          },
          [_c("router-view")],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a87c4e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a87c4e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homepage/homepage.vue
// module id = null
// module chunks = 